import React, { Component } from 'react';
import primalIcon from './assets/logo.svg';
import primalIconDark from './assets/logo-gold.svg';

class LazyCardImage extends Component {
  constructor(props) {
    super(props);
    this.state = { errored: false, isDark: document.documentElement.classList.contains('tw-dark') };
    this._darkObserver = null;
  }

  componentDidMount() {
    var comp = this;
    this._darkObserver = new MutationObserver(function() {
      var dark = document.documentElement.classList.contains('tw-dark');
      if (dark !== comp.state.isDark) comp.setState({ isDark: dark });
    });
    this._darkObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  componentWillUnmount() {
    if (this._darkObserver) this._darkObserver.disconnect();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this.setState({ errored: false });
    }
  }

  render() {
    const { src, alt, fallbackSize, eager, rotate } = this.props;
    const { errored, isDark } = this.state;
    const icon = isDark ? primalIconDark : primalIcon;
    const size = fallbackSize || 'tw-w-24 tw-h-24';
    const rotateStyle = rotate ? { transform: 'rotate(' + rotate + 'deg) scale(1.3)', transformOrigin: 'center center' } : undefined;

    if (!src || errored) {
      return <img src={icon} alt={alt || 'No image'} className={`${size} tw-opacity-20`} />;
    }

    if (eager) {
      return (
        <img
          src={src}
          alt={alt}
          className="tw-max-w-full tw-max-h-full tw-object-contain"
          style={rotateStyle}
          onError={() => this.setState({ errored: true })}
        />
      );
    }

    return (
      <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-[#f5f5f5] dark:tw-bg-[#1a1a1a]">
          <img src={icon} alt="" className={`${size} tw-opacity-10 tw-animate-pulse`} />
        </div>
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="tw-max-w-full tw-max-h-full tw-object-contain"
          style={Object.assign({ position: 'relative' }, rotateStyle || {})}
          onError={() => this.setState({ errored: true })}
        />
      </div>
    );
  }
}

export default LazyCardImage;
